var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',{attrs:{"title":"Tab"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.song.tab),expression:"song.tab"}],attrs:{"readonly":""},domProps:{"value":(_vm.song.tab)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.song, "tab", $event.target.value)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3732bc1d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewSong/Tab.vue
// module id = null
// module chunks = 